var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPineNuts({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E6393D;}\n\t.st1{fill:#FFDC89;}\n\t.st2{fill:#FFE9C6;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M111.21,148.66c-15.48,2.2-21.86-2.61-22.85-9.54c-0.99-6.92,3.8-13.33,19.28-15.53 c15.48-2.2,35.62-0.57,36.78,7.55C145.65,139.74,126.7,146.46,111.21,148.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M144.42,131.15c-0.16-1.09-0.66-2.06-1.44-2.92c-3.26,6.96-19.26,12.26-32.66,14.17 c-13.06,1.86-19.65-1.28-21.98-6.46c-0.15,1.04-0.13,2.11,0.02,3.19c0.99,6.92,7.37,11.74,22.85,9.54 C126.7,146.46,145.65,139.74,144.42,131.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M111.15,131.98c-6.73,0.96-12.32,0.77-12.49-0.41c-0.17-1.19,5.15-2.92,11.88-3.88 c6.73-0.96,12.32-0.77,12.49,0.41C123.2,129.28,117.88,131.02,111.15,131.98z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M83.4,129.82c-12.37,9.56-20.3,8.53-24.58,3c-4.28-5.53-3.28-13.47,9.09-23.03 c12.37-9.56,30.69-18.1,35.71-11.6C108.92,105.05,95.77,120.26,83.4,129.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.61,98.19c-0.67-0.87-1.59-1.46-2.7-1.83c0.61,7.66-10.68,20.17-21.39,28.46 c-10.44,8.07-17.71,8.59-22.3,5.24c0.39,0.98,0.93,1.9,1.6,2.77c4.28,5.53,12.21,6.57,24.58-3 C95.77,120.26,108.92,105.05,103.61,98.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M75.09,115.35c-5.38,4.16-10.33,6.76-11.07,5.81c-0.73-0.95,3.03-5.09,8.41-9.25 c5.38-4.16,10.33-6.76,11.07-5.81C84.24,107.05,80.47,111.19,75.09,115.35z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.44,104.3c-10.74-11.36-10.5-19.36-5.42-24.16c5.08-4.8,13.08-4.6,23.82,6.77s21.04,28.75,15.08,34.38 C147.62,127.25,131.18,115.67,120.44,104.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M153.92,121.29c0.8-0.76,1.3-1.73,1.55-2.86c-7.57,1.36-21.13-8.63-30.43-18.47 c-9.06-9.59-10.31-16.78-7.42-21.67c-0.94,0.48-1.8,1.11-2.6,1.86c-5.08,4.8-5.33,12.8,5.42,24.16 C131.18,115.67,147.62,127.25,153.92,121.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M134.02,94.61c-4.67-4.94-7.75-9.61-6.88-10.44c0.87-0.82,5.36,2.52,10.03,7.46 c4.67,4.94,7.75,9.61,6.88,10.44C143.18,102.89,138.69,99.55,134.02,94.61z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M92.47,90.77c-13.27,8.28-21.05,6.46-24.75,0.52c-3.7-5.93-1.92-13.73,11.35-22.01 c13.27-8.28,32.35-14.93,36.69-7.97C120.35,68.67,105.74,82.49,92.47,90.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115.76,61.31c-0.58-0.93-1.44-1.62-2.5-2.09c-0.16,7.69-12.65,19-24.14,26.17 c-11.19,6.98-18.48,6.78-22.71,2.98c0.29,1.01,0.73,1.99,1.31,2.91c3.7,5.93,11.49,7.76,24.75-0.52 C105.74,82.49,120.35,68.67,115.76,61.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M85.66,75.53c-5.77,3.6-10.96,5.69-11.59,4.68c-0.63-1.02,3.53-4.76,9.3-8.36c5.77-3.6,10.96-5.69,11.59-4.68 C95.59,68.19,91.43,71.93,85.66,75.53z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPineNuts);
export default __webpack_public_path__ + "static/media/Pine_nuts.fefbb3ea85f02dedf29de2a16e330a9d.svg";
export { ForwardRef as ReactComponent };